/**
 * Creates an object with key-value pairs equal to the passed object's first level of keys.
 * @example
 * // returns { someKey: 'someKey' }
 * nameOfObjectKeys({ someKey: 'someValue' });
 * @example
 * // returns { someKey: 'someKey' }
 * nameOfObjectKeys({ someKey: { nestedKey: 'nestedValue' } });
 * @param obj Object to get the keys from.
 * @returns An object with key-value pairs of each key.
 */
export const nameOfObjectKeys = <T extends Record<keyof T, unknown>>(obj: T): Record<keyof T, keyof T> =>
  Object.fromEntries(Object.keys(obj).map(key => [key, key])) as Record<keyof T, keyof T>;
